if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        // Matches your Liquid container: <div id="QuickAddInfo-{{ id }}"></div>
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);

        if (this.modalContent) this.modalContent.innerHTML = "";

        // Safely destroy any Swipers that might have been init’d inside the modal
        try {
          $(".js-media-list").each(function () {
            if (this.swiper) this.swiper.destroy();
          });
          $(".js-media-sublist").each(function () {
            if (this.swiper) this.swiper.destroy();
          });
        } catch (_) {}

        subSliderInit(true);
        sliderInit(true);
        updatethumbnail();

        // Remove any section-scoped styles we injected
        this.removeInjectedSectionStyles();

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        if (!opener) return;

        opener.setAttribute("aria-disabled", "true");
        opener.classList.add("loading");
        const spinner = opener.querySelector(".loading-overlay__spinner");
        if (spinner) spinner.classList.remove("hidden");

        // Open the modal shell immediately (your Liquid provides the dialog container)
        super.show(opener);

        // Trap focus after transition
        this.addEventListener(
          "transitionend",
          () => {
            const dialog = this.querySelector('[role="dialog"]') || this;
            const focusEl =
              this.querySelector(".quick-add-modal__content") ||
              this.querySelector(".quick-add-modal__content-info") ||
              dialog;
            if (typeof trapFocus === "function") trapFocus(dialog, focusEl);
          },
          { once: true }
        );

        const productUrl = opener.getAttribute("data-product-url");
        if (!productUrl) {
          this.modalContent.innerHTML = `<p>Missing product URL.</p>`;
          this._cleanupLoader(opener, spinner);
          return;
        }

        fetch(productUrl)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, "text/html");
            this.applyTemplateClassesFrom(doc);

            const main = doc.querySelector("main#MainContent") || doc.body;
            const productSection =
              doc.querySelector('section[id^="MainProduct-"]') ||
              doc.querySelector('section.product-section[id^="MainProduct-"]') ||
              doc.querySelector("section.product-section") ||
              doc.querySelector('[data-section-type="main-product"]') ||
              doc.querySelector('[data-section-type="product"]') ||
              main;

            if (!productSection) {
              this.modalContent.innerHTML = `
                <p>Sorry—couldn’t locate the product section.</p>
                <p><a class="button button--simple button--small" href="${productUrl}">Open full product page</a></p>
              `;
              return;
            }

            // Bring in CSS links from the product page (deduped)
            doc.querySelectorAll('link[rel="stylesheet"][href]').forEach((link) => {
              const href = link.getAttribute("href");
              if (!href) return;
              if (!document.head.querySelector(`link[rel="stylesheet"][href="${href}"]`)) {
                const l = document.createElement("link");
                l.rel = "stylesheet";
                l.href = href;
                if (link.media) l.media = link.media;
                if (link.crossOrigin) l.crossOrigin = link.crossOrigin;
                document.head.appendChild(l);
              }
            });

            // Clone & rewrite section IDs to avoid collisions
            const sectionClone = productSection.cloneNode(true);
            const sectionId = sectionClone.dataset?.section;

            if (sectionId) {
              sectionClone.innerHTML = sectionClone.innerHTML.replaceAll(
                sectionId,
                `quickadd-${sectionId}`
              );

              // Copy any section-scoped <style> and rewrite to prefixed id
              this.injectSectionScopedStyles(doc, sectionId);

              sectionClone
                .querySelectorAll("variant-selects, variant-radios")
                .forEach((el) => {
                  el.dataset.originalSection = sectionId;
                  el.setAttribute("data-update-url", "false"); // avoid URL changes
                });
            }

            // Remove elements that don't belong in the modal
            sectionClone
              .querySelectorAll("pickup-availability, product-modal, .customer")
              .forEach((el) => el.remove());

            // Inject the product HTML into QuickAddInfo container
            this.setInnerHTML(this.modalContent, sectionClone.innerHTML, opener);

            // Notify theme scripts a section has "loaded"
            if (sectionId) {
              document.dispatchEvent(
                new CustomEvent("shopify:section:load", {
                  bubbles: true,
                  detail: { sectionId: `quickadd-${sectionId}` },
                })
              );
            }

            // A11y tweak for gallery list
            const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
            if (galleryList) {
              galleryList.setAttribute("role", "presentation");
              galleryList
                .querySelectorAll('[id^="Slide-"]')
                .forEach((li) => li.setAttribute("role", "presentation"));
            }

            // Responsive image sizes for column layout
            const productRoot = this.modalContent.querySelector(".product");
            if (productRoot && productRoot.classList.contains("product--columns")) {
              const imgs = productRoot.querySelectorAll(".product__media img");
              let sizes =
                "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";
              if (productRoot.classList.contains("product--medium")) {
                sizes = sizes.replace("715px", "605px");
              }
              if (productRoot.classList.contains("product--small")) {
                sizes = sizes.replace("715px", "495px");
              }
              imgs.forEach((img) => img.setAttribute("sizes", sizes));
            }

            // Re-init Shopify runtime bits
            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            // Dropdown behavior
            $(".product-form__input--dropdown").each(function () {
              const elListItem = $(this).find(".dropdown-select ul li");
              const elItem = $(this).find(".dropdown-select ul");
              const selectedText = $(this).find(".dropdown-select .select-label");

              selectedText.on("click", function (e) {
                elItem.toggleClass("active");
                if (elItem.hasClass("active")) {
                  e.stopPropagation();
                  $(document).one("click", function () {
                    elItem.removeClass("active");
                  });
                }
              });

              elListItem.on("click", function () {
                if (!$(this).find("input").hasClass("disabled")) {
                  selectedText.text($(this).text()).attr("title", $(this).text());
                }
                elItem.removeClass("active");
                document.activeElement.blur();
              });
            });

            // If you rely on Swipers inside quick view, refresh them
            subSliderInit(true, 5, 12);
            sliderInit();
            updatethumbnail();
          })
          .catch((e) => {
            console.error("Quick add modal error:", e);
            this.modalContent.innerHTML = `
              <p>We couldn’t load the product content.</p>
              <p><a class="button button--simple button--small" href="${productUrl}">Open full product page</a></p>
            `;
          })
          .finally(() => this._cleanupLoader(opener, spinner));
      }

      setInnerHTML(element, html, opener) {
        if (!element) return;

        element.innerHTML = html;

        // Re-inject inline <script> so they execute
        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const s = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((a) => s.setAttribute(a.name, a.value));
          s.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(s, oldScriptTag);
        });

        // Optional: “View full details” button
        const infoWrapper = element.querySelector(".product__info-wrapper");
        const href = opener?.getAttribute("data-product-url");
        if (infoWrapper && href) {
          const moreBtn = document.createElement("div");
          moreBtn.className = "button-view-full";
          moreBtn.innerHTML = `
            <a href="${href}" class="button button--simple button--small">
              <span class="button-label">${
                (window.theme && theme.quickviewMore) || "View full details"
              }</span>
            </a>`;
          infoWrapper.appendChild(moreBtn);
        }
      }

      applyTemplateClassesFrom(doc) {
        // Copy only “template-*” classes to keep styling consistent
        const templateClasses = Array.from(doc.body.classList).filter((c) =>
          c.startsWith("template-")
        );
        const shell = this.querySelector('[role="dialog"]') || this;
        templateClasses.forEach((c) => shell.classList.add(c));
        // Ensure we always look like a product template
        shell.classList.add("template-product");
      }

      injectSectionScopedStyles(doc, originalSectionId) {
        // Find <style> blocks that mention this section id
        const styles = Array.from(doc.querySelectorAll("style")).filter(
          (s) => s.textContent && s.textContent.includes(originalSectionId)
        );

        this._injectedStyleNodes = this._injectedStyleNodes || [];

        styles.forEach((s) => {
          const node = document.createElement("style");
          node.setAttribute("data-quickadd-style", originalSectionId);
          // Rewrite selectors to the quickadd- prefixed id
          node.textContent = s.textContent.replaceAll(
            originalSectionId,
            `quickadd-${originalSectionId}`
          );
          document.head.appendChild(node);
          this._injectedStyleNodes.push(node);
        });
      }

      removeInjectedSectionStyles() {
        if (!this._injectedStyleNodes) return;
        this._injectedStyleNodes.forEach((n) => n.remove());
        this._injectedStyleNodes = [];
      }

      _cleanupLoader(opener, spinner) {
        if (opener) {
          opener.removeAttribute("aria-disabled");
          opener.classList.remove("loading");
          if (spinner) spinner.classList.add("hidden");
        }
        const drawer = document.querySelector("cart-drawer");
        if (drawer) drawer.classList.remove("active");
      }
    }
  );
}